{
  "backToDevices": "Retour aux appareils",
  "connectionsTitle": "Relations",
  "currentStatusTitle": "Statut actuel",
  "deviceInfoTitle": "Informations sur l'appareil",
  "helpBody": "Le profil de l'appareil vous permet de gérer des appareils individuels. Vous pouvez modifier la configuration d'un appareil, afficher l'historique des mises à jour qu'il a effectuées et des actions qu'il a exécutées, et bien plus encore.",
  "deviceIsNotCenterPivot": "Cette fonctionnalité n'est disponible que pour les appareils configurés comme pivots centraux.",
  "deviceLocationNotAvailable": "Localisation de l'appareil non disponible",
  "deviceNotFoundWithCodaDeviceAlias": "Aucun appareil avec l'alias {{codaDeviceAlias}} n'a été trouvé.",
  "linkToActionHistory": "Commandes",
  "linkToConfiguration": "Configuration",
  "linkToEventHistory": "Histoire",
  "linkToLanding": "Maison",
  "linkToNotifications": "Notifications",
  "locationTitle": "Emplacement",
  "noWarnings": "Aucun avertissement trouvé pour cet appareil.",
  "note": "Note",
  "title": "Profil de l'appareil",
  "warningsTitle": "Avertissements"
}
